/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dashboard.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../shared/panel/panel.component.ngfactory';
import * as i3 from '../../../../src/app/shared/panel/panel.component';
import * as i4 from './visitor/visitor.component.ngfactory';
import * as i5 from '../../../../src/app/dashboard/visitor/visitor.component';
import * as i6 from './demographics/demographics.component.ngfactory';
import * as i7 from '../../../../src/app/dashboard/demographics/demographics.component';
import * as i8 from './revenue/revenue.component.ngfactory';
import * as i9 from '../../../../src/app/dashboard/revenue/revenue.component';
import * as i10 from './radar/radar.component.ngfactory';
import * as i11 from '../../../../src/app/dashboard/radar/radar.component';
import * as i12 from './data/data.component.ngfactory';
import * as i13 from '../../../../src/app/dashboard/data/data.component';
import * as i14 from './calendar/calendar.component.ngfactory';
import * as i15 from '../../../../src/app/dashboard/calendar/calendar.component';
import * as i16 from './map/map.component.ngfactory';
import * as i17 from '../../../../src/app/dashboard/map/map.component';
import * as i18 from '../shared/grid/grid.component.ngfactory';
import * as i19 from '../../../../src/app/shared/grid/grid.component';
import * as i20 from '../../../../src/app/dashboard/dashboard.component';
const styles_DashboardComponent:any[] = [i0.styles];
export const RenderType_DashboardComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_DashboardComponent,data:{}});
function View_DashboardComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,1,'admin-dashboard-visitor',
          ([] as any[]),(null as any),(null as any),(null as any),i4.View_DashboardVisitorComponent_0,
          i4.RenderType_DashboardVisitorComponent)),i1.ɵdid(49152,(null as any),0,
          i5.DashboardVisitorComponent,([] as any[]),(null as any),(null as any))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,1).tabbed;
        const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
        const currVal_2:any = i1.ɵnov(_v,1).isClosed;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
      });
}
function View_DashboardComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),{tabbed:[0,'tabbed']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,1,'admin-dashboard-demographics',
          ([] as any[]),(null as any),(null as any),(null as any),i6.View_DashboardDemographicsComponent_0,
          i6.RenderType_DashboardDemographicsComponent)),i1.ɵdid(4374528,(null as any),
          0,i7.DashboardDemographicsComponent,([] as any[]),(null as any),(null as any))],
      (_ck,_v) => {
        const currVal_3:any = true;
        _ck(_v,1,0,currVal_3);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,1).tabbed;
        const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
        const currVal_2:any = i1.ɵnov(_v,1).isClosed;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
      });
}
function View_DashboardComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),{tabbed:[0,'tabbed']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,1,'admin-dashboard-revenue',
          ([] as any[]),(null as any),(null as any),(null as any),i8.View_DashboardRevenueComponent_0,
          i8.RenderType_DashboardRevenueComponent)),i1.ɵdid(49152,(null as any),0,
          i9.DashboardRevenueComponent,([] as any[]),(null as any),(null as any))],
      (_ck,_v) => {
        const currVal_3:any = true;
        _ck(_v,1,0,currVal_3);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,1).tabbed;
        const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
        const currVal_2:any = i1.ɵnov(_v,1).isClosed;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
      });
}
function View_DashboardComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,1,'admin-dashboard-radar',
          ([] as any[]),(null as any),(null as any),(null as any),i10.View_DashboardRadarComponent_0,
          i10.RenderType_DashboardRadarComponent)),i1.ɵdid(4243456,(null as any),0,
          i11.DashboardRadarComponent,([] as any[]),(null as any),(null as any)),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),3,'admin-panel',([] as any[]),[[2,
              'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',(null as any)]],
              (null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),{tabbed:[0,'tabbed']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,1,'admin-dashboard-data',
          ([] as any[]),(null as any),(null as any),(null as any),i12.View_DashboardDataComponent_0,
          i12.RenderType_DashboardDataComponent)),i1.ɵdid(4243456,(null as any),0,
          i13.DashboardDataComponent,([] as any[]),(null as any),(null as any))],(_ck,
      _v) => {
    const currVal_6:any = true;
    _ck(_v,5,0,currVal_6);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = i1.ɵnov(_v,5).tabbed;
    const currVal_4:any = i1.ɵnov(_v,5).isMinimized;
    const currVal_5:any = i1.ɵnov(_v,5).isClosed;
    _ck(_v,4,0,currVal_3,currVal_4,currVal_5);
  });
}
function View_DashboardComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),{tabbed:[0,'tabbed']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,1,'admin-dashboard-calendar',
          ([] as any[]),(null as any),(null as any),(null as any),i14.View_DashboardCalendarComponent_0,
          i14.RenderType_DashboardCalendarComponent)),i1.ɵdid(4374528,(null as any),
          0,i15.DashboardCalendarComponent,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),3,'admin-panel',([] as any[]),
          [[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',(null as any)]],
          (null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,1,'admin-dashboard-map',
          ([] as any[]),(null as any),(null as any),(null as any),i16.View_DashboardMapComponent_0,
          i16.RenderType_DashboardMapComponent)),i1.ɵdid(49152,(null as any),0,i17.DashboardMapComponent,
          ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    const currVal_3:any = true;
    _ck(_v,1,0,currVal_3);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = i1.ɵnov(_v,5).tabbed;
    const currVal_5:any = i1.ɵnov(_v,5).isMinimized;
    const currVal_6:any = i1.ɵnov(_v,5).isClosed;
    _ck(_v,4,0,currVal_4,currVal_5,currVal_6);
  });
}
export function View_DashboardComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'admin-grid',([] as any[]),
      (null as any),(null as any),(null as any),i18.View_GridComponent_0,i18.RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i19.GridComponent,([] as any[]),{cols:[0,'cols']},
          (null as any)),i1.ɵqud(603979776,1,{templates:1}),i1.ɵpad(1),(_l()(),i1.ɵand(0,
          [[1,2]],(null as any),0,(null as any),View_DashboardComponent_1)),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),5,'admin-grid',([] as any[]),(null as any),
              (null as any),(null as any),i18.View_GridComponent_0,i18.RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i19.GridComponent,([] as any[]),{cols:[0,'cols']},
          (null as any)),i1.ɵqud(603979776,2,{templates:1}),i1.ɵpad(2),(_l()(),i1.ɵand(0,
          [[2,2]],(null as any),0,(null as any),View_DashboardComponent_2)),(_l()(),
          i1.ɵand(0,[[2,2]],(null as any),0,(null as any),View_DashboardComponent_3)),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),5,'admin-grid',([] as any[]),(null as any),
          (null as any),(null as any),i18.View_GridComponent_0,i18.RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i19.GridComponent,([] as any[]),{cols:[0,'cols']},
          (null as any)),i1.ɵqud(603979776,3,{templates:1}),i1.ɵpad(2),(_l()(),i1.ɵand(0,
          [[3,2]],(null as any),0,(null as any),View_DashboardComponent_4)),(_l()(),
          i1.ɵand(0,[[3,2]],(null as any),0,(null as any),View_DashboardComponent_5))],
      (_ck,_v) => {
        const currVal_0:any = _ck(_v,3,0,12);
        _ck(_v,1,0,currVal_0);
        const currVal_1:any = _ck(_v,8,0,5,7);
        _ck(_v,6,0,currVal_1);
        const currVal_2:any = _ck(_v,14,0,4,8);
        _ck(_v,12,0,currVal_2);
      },(null as any));
}
export function View_DashboardComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_DashboardComponent_0,
      RenderType_DashboardComponent)),i1.ɵdid(49152,(null as any),0,i20.DashboardComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const DashboardComponentNgFactory:i1.ComponentFactory<i20.DashboardComponent> = i1.ɵccf('ng-component',
    i20.DashboardComponent,View_DashboardComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./$$_gendir/src/app/dashboard/dashboard.component.ngfactory.ts